import React from 'react'
import { VStack, HStack, Text, Button } from '@chakra-ui/react'

export const PaymentMethodUsed = ({ cardNumberMasked, onChangeCard }) => (
  <VStack spacing={3} align="stretch">
    {/* 前回使用したカード */}
    <HStack justify="space-between" align="center">
      <Text fontSize="sm" fontWeight="600" color="label.primary" lineHeight="20px">
        前回使用したカード
      </Text>
      <Button
        size="sm"
        fontSize="11px"
        fontWeight="600"
        color="label.primary"
        bg="bg.secondary"
        borderRadius="3px"
        h="18px"
        lineHeight="14px"
        px="8px"
        onClick={onChangeCard}
        _hover={{ opacity: 0.8 }}
      >
        他のカードを使う
      </Button>
    </HStack>

    {/* カード番号 */}
    <HStack justify="space-between" align="flex-start">
      <Text fontSize="11px" fontWeight="300" color="label.primary" lineHeight="normal">
        クレジットカード番号
      </Text>
      <Text fontSize="11px" fontWeight="300" color="label.primary" lineHeight="normal">
        {cardNumberMasked}
      </Text>
    </HStack>
  </VStack>
)
